export default "__VITE_ASSET__CsFezd1p__"